export function buildRecentHoursShortcuts (vm, hoursList = [1, 6]) {
  const keys = { 1: 'public.name50', 6: 'public.name49' }
  return hoursList.map((h) => ({
    text: vm.$t(keys[h]),
    onClick (picker) {
      const end = vm.$tz ? vm.$tz.accountNow().toDate() : new Date()
      const start = new Date(end)
      start.setTime(start.getTime() - h * 3600000)
      picker.$emit('pick', [start, end])
    }
  }))
}

export function buildDisabledFutureDate (vm) {
  return (time) => {
    const now = vm.$tz ? vm.$tz.accountNow().toDate() : new Date()
    return time.getTime() > now.getTime()
  }
}
